export default __webpack_public_path__ + "static/media/logo_newtral_black.2e3b68c1.svg";